var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-row"},[_c('locale-toggle-btn'),_c('share-btn',{staticClass:"animate__animated animate__flip animate__delay-5s animate__slow"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }